






































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import OrderApi from '@/api/marketing/couponpack/index'
import ViewUI from 'view-design'
import ShopInfoApi from '@/api/shopInfo/index'
import ShippingCompany from '@/api/shipping/index'
import appconst from "@/lib/appconst"
@Component({
  components: {
    CustomForm,
  },
})
export default class CouponpackOrderList extends AbpBase {
  uploadUrl = `${appconst.remoteServiceBaseUrl}/api/OrderManagement/order/ImportOrderFile`
  orderDeliverModal: boolean = false
  sendGoodsLoading: boolean = false
  autoSendLoading: boolean = false
  uploading: boolean = false
  headers: any = {
    authorization: 'Bearer ' + localStorage.getItem('access_token')
  }
  sendGoodsType: string = '自动发货'
  shipmentList: any[] = []
  orderDeliverConfig: any = {
    expressCompanyId: '',
    shipmentNumber: '',
    expressCompanyName: '',
  }
  filters1 = [
    {
      label: '输入搜索',
      type: 'input',
      props: {
        placeholder: '订单编号',
      },
      key: 'orderNo',
    },
  ]

  columns: any[] = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center',
    // },
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },
    // {
    //   title: '券包ID',
    //   key: 'packageId',
    //   align: 'center',
    // },
    {
      title: '订单总价',
      key: 'orderTotal',
      align: 'center',
    },
    {
      title: '订单状态',
      slot: 'orderStatus',
      align: 'center',
    },
    {
      title: '支付时间',
      slot: 'payTime',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  loading: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  tabList = [
    {
      text: '全部订单',
      value: null,
    },
    {
      text: '待支付',
      value: 0,
    },
    {
      text: '已完成',
      value: 1,
    },
    {
      text: '已取消',
      value: 2
    },
  ]
  activeTab = 0
  isCheckAll: boolean = false
  exporting: boolean = false
  selectedIds: any = new Set()
  isCrowdfundingOrder: boolean = false
  selectedItems: any = {}

  get filters() {
    return this.filters1
  }

  tenantId: any = localStorage.getItem('tenantGuid')
    ? (JSON.parse(localStorage.getItem('tenantGuid')) as any).tenantGuid
    : null
  get tenantGuid() {
    return this.$store.state.app.tenantGuid.tenantGuid
  }
  @Watch('tenantGuid')
  gettenantGuid(e) {
    this.tenantId = e
    this.submitFn()
  }
  created() {

  }
  mounted() {
  }

  @Watch('$route', {
    immediate: true,
  })
  routeWatch(value) {
    ViewUI['LoadingBar'].finish()
    this.activeTab = 0
    this.page = {
      totalCount: 0,
      currentPage: 1,
      maxResultCount: 10,
    }
    this.tableData = []
    let form: any = this.$refs.lineForm
    if (form) {
      form.reset()
    }
    this.getOrderList()
  }

  // 导出订单
  exportExcel() {
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    let { page, activeTab, tabList } = this
    this.exporting = true
    let orderNo = form ? form['orderNo'] : null
    let orderFullStatus = tabList[activeTab].value

    OrderApi.exportExcel(
      page.maxResultCount,
      page.currentPage,
      orderFullStatus,
      orderNo,
    )
      .then((res) => {
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }

  get showBatchCancel() {
    return ![2, 3, 5, 4].includes(this.tabList[this.activeTab].value)
  }

  get showBatchDeleted() {
    return [null, 4, 6].includes(this.tabList[this.activeTab].value)
  }
  get showBatchPrint() {
    return [null, 1].includes(this.tabList[this.activeTab].value)
  }

  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', this.$route.name == 'orderList' ? '订单列表.xlsx' : '众筹订单.xlsx')

    document.body.appendChild(link)
    link.click()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  onSubmit(form, valid) {
    if (valid) {
      this.selectedIds = new Set()
      this.getOrderList(form)
    } else {
      this.$Message.error('验证失败')
    }
  }

  changePage(e) {
    this.page.currentPage = e
    this.submitFn()
    setTimeout(() => {
      this.setChecked()
    }, 200)
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.submitFn()
  }

  /**
   * 选择option
   */
  selectOption(value) {
    console.log(value)
    let obj = this.shipmentList.find((item) => item.id == value)
    this.orderDeliverConfig.expressCompanyName = obj.expressCompanyName
  }
  /**
   * 获取订单列表
   */
  getOrderList(form?) {
    let { page, activeTab, tabList } = this
    this.loading = true
    this.isCheckAll = false
    let orderNo = form ? form['orderNo'] : null
    let orderFullStatus = tabList[activeTab].value
    OrderApi.getCouponpackOrderList(
      page.maxResultCount,
      page.currentPage,
      orderFullStatus,
      orderNo,
    )
      .then((res) => {
        this.loading = false
        if (res.data) {
          this.tableData = res.data.items
          page.totalCount = res.data.totalCount
        }
      })
      .catch((err) => {
        this.loading = false
      })
  }

  /**
   * 查看订单详情
   */
  orderDetailFn(row) {
    this.$router.push({
      name: 'couponpackOrderDetail',
      query: {
        id: row.id,
      },
    })
  }

  uploadProgress() {
    this.uploading = true
  }
  uploadSuccess(e) {
    // this.$Message.success("上传文件成功，导入比较耗时，请稍后刷新查看结果");
    // console.log(e);
    this.$Notice.success({
      desc: `成功导入${e}条发货订单`
    })
    this.uploading = false
    this.submitFn()
  }
  uploadError(err) {
    console.log('上传报错', err);
    this.$Notice.error({
      desc: '导入文件错误，请重新选择文件'
    })
    this.uploading = false
  }

  /**
   * 取消待付款订单
   */
  cancelOrder(row) {
    this.$Modal.confirm({
      title: '提示',
      content: '确认取消此订单？',
      onOk: () => {
        this.loading = true
        let list: any = [row.id]
        OrderApi.cancelOrder(list)
          .then((res) => {
            this.loading = false
            this.$Notice.success({ desc: '取消成功' })
            this.submitFn()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }

  // cancelOrderAll() {
  //   let selection = (this.$refs.selection as any).getSelection()
  //   const ids: any[] = []
  //   selection.forEach((x) => {
  //     if (x.orderFullStatus < 2 || x.orderFullStatus == 20) {
  //       ids.push(x.id)
  //     }
  //   })
  //   if (ids.length === 0) {
  //     this.$Notice.warning({ title: '请先勾选待支付/待发货/待成团订单' })
  //     return
  //   } else {
  //     this.$Modal.confirm({
  //       title: '提示',
  //       content: '确认取消已选中的待支付/待发货/待成团订单？',
  //       onOk: () => {
  //         this.loading = true
  //         OrderApi.cancelOrder(ids)
  //           .then((res) => {
  //             this.loading = false
  //             this.$Notice.success({ desc: '取消成功' })
  //             this.submitFn()
  //           })
  //           .catch((err) => {
  //             this.loading = false
  //           })
  //       },
  //     })
  //   }
  // }

  /**
   * 批量删除已取消/已关闭订单
   */
  // deleteSelectd() {
  //   let selection = (this.$refs.selection as any).getSelection()
  //   const ids: any = []
  //   selection.forEach((x) => {
  //     if (x.orderFullStatus === 4 || x.orderFullStatus === 6) {
  //       ids.push(x.id)
  //     }
  //   })
  //   if (ids.length === 0) {
  //     this.$Notice.warning({ title: '请先勾选已取消/已关闭订单' })
  //     return
  //   } else {
  //     this.$Modal.confirm({
  //       title: '提示',
  //       content: `确认删除已取消/已关闭订单？`,
  //       onOk: () => {
  //         this.loading = true
  //         OrderApi.deleteOrder(ids)
  //           .then((res) => {
  //             this.loading = false
  //             this.$Notice.error({ desc: '删除成功' })
  //             this.submitFn()
  //           })
  //           .catch((err) => {
  //             this.loading = false
  //           })
  //       },
  //     })
  //   }
  // }

  handleTableAllCancel() {
    this.isCheckAll = false
    let data = (this.$refs.selection as any).data
    data.forEach((item) => {
      if (this.selectedIds.has(item.id)) {
        this.selectedIds.delete(item.id)
      }
    })
  }

  handleTableAll(selection) {
    this.isCheckAll = true
    selection.forEach((item) => {
      this.selectedIds.add(item.id)
    })
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
      ; (this.$refs.selection as any).selectAll(!this.isCheckAll)
  }
  handleSelect(slection, row) {
    this.selectedIds.add(row.id)
  }
  handleCancel(slection, row) {
    this.selectedIds.delete(row.id)
  }
  setChecked() {
    // 找到绑定的table的ref对应的dom，找到table的objData对象，objData保存的是当前页的数据
    let objData = (this.$refs.selection as any).objData
    for (let index in objData) {
      if (this.selectedIds.has(objData[index].id)) {
        // cy 弊端 每次切换select都会触发table的on-select事件
        // this.$refs.purchaseTable.toggleSelect(index) // 在保存选中的ids的set合集里找与当前页数据id一样的行，使用toggleSelect（index），将这一行选中
        // cy 改进
        objData[index]._isChecked = true
      }
    }
    // console.log(objData)
  }
  // 打印发货单
  printOrder() {
    var selected = (this.$refs.selection as any).getSelection()
    const ids: any[] = []
    selected.forEach((x) => {
      if (x.orderFullStatus === 1) {
        ids.push(x.id)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选待发货订单' })
      return
    } else {
      this.$router.push({
        name: 'printOrder',
        params: {
          ids: encodeURIComponent(ids.join(',')),
        },
      })
    }
  }
}
